import React, { Component } from "react";
import { findDOMNode } from "react-dom";
import { DayPicker } from "react-day-picker";
import i18n from "../../../i18n";
import { enGB, es, fr, de } from "date-fns/locale";
import { CalendarIcon, ExclamationCircleIcon } from "@heroicons/react/20/solid";

const locales = { en: enGB, es, fr, de };
const overlayStyle = {
    position: "absolute",
    background: "white",
    boxShadow: "0 2px 5px rgba(0, 0, 0, .15)",
};

export default class DayPickerComponent extends Component {
    focus() {
        findDOMNode(this.refs.input).focus();
    }

    blur() {
        findDOMNode(this.refs.input).blur();
    }

    render() {
        const { className, handleMouseDown, showPicker, input, picker, toggleOverlay } =
            this.props;

        return (
            <>
                <div
                    className="relative mt-1 rounded-md shadow-sm"
                    onMouseDown={handleMouseDown}
                >
                    <input
                        {...input}
                        placeholder={"jj / mm / aaaa"}
                        autoComplete="off"
                        type="text"
                        ref="input"
                        name={name}
                        className="
                          group-[.has-error]:input-error block w-full rounded-md border-gray-300 pr-10 focus:border-orange-500 focus:ring-orange-500
                          sm:text-sm
                          "
                    />
                    <div
                        className="pointer-events-none absolute inset-y-0 right-0  hidden items-center pr-3 group-[.has-error]:flex"
                        onClick={toggleOverlay}
                    >
                        <ExclamationCircleIcon
                            className="h-5 w-5 text-red-500"
                            aria-hidden="true"
                        />
                    </div>
                    <div
                        className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 group-[.has-error]:hidden"
                        onClick={toggleOverlay}
                    >
                        <CalendarIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                        />
                    </div>
                    {showPicker && (
                        <div style={{ position: "relative", zIndex: 9999 }}>
                            <div style={overlayStyle}>
                                <DayPicker
                                    {...picker}
                                    locale={locales[i18n.language]}
                                    firstDayOfWeek={1}
                                    modifiersStyles={{
                                        selected: { backgroundColor: 'rgb(249 115 22)' }
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </>
        );
    }
}
